import type { Asset, AssetFields } from 'contentful';

export const getCFImageAspectRatio = (image: Asset) => {
  if (
    !image ||
    !image.fields ||
    !image.fields.file ||
    !image.fields.file.details
  ) {
    return 1; // Default aspect ratio if no image data is available
  }

  const assetFields = image.fields as AssetFields;
  const { width, height } = assetFields.file!.details!.image || {
    width: 1,
    height: 1,
  };
  return width / height;
};

export const getCFImageWidthFromHeight = (image: Asset, height: number) => {
  const aspectRatio = getCFImageAspectRatio(image);
  return height * aspectRatio;
};

export const getCFImageHeightFromWidth = (image: Asset, width: number) => {
  const aspectRatio = getCFImageAspectRatio(image);
  return width / aspectRatio;
};
